import React, { useState } from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';

import Checkbox from '../../../common/Checkbox';

const CheckAnswer = ({ tempId, selectedValue, settings, onChange }) => {
  const [checked, toggleCheckbox] = useState(selectedValue === 'true');

  const handleChange = value => {
    toggleCheckbox(value);
    onChange(value ? 'true' : null);
  };

  return (
    <Checkbox
      label={get(settings, 'meta.consentDescription.checkboxText')}
      checked={checked}
      id={tempId}
      onChange={handleChange}
    />
  );
};

CheckAnswer.propTypes = {
  onChange: PropTypes.func,
  settings: PropTypes.object,
  selectedValue: PropTypes.string,
  tempId: PropTypes.string,
};

export default CheckAnswer;



// WEBPACK FOOTER //
// ./src/components/SequentialSurvey/Answers/CheckAnswer/index.jsx